import './index.scss';

import imgexport2 from '../../../../../assets/images/para-sua-empresa/produtos-protecao/img-protecao2@2x.png';

export const SwapCambial = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> Swap Cambial </h1>

                <p>
                    O swap cambial é um instrumento financeiro sofisticado que pode ser usado
                    para gerenciar o risco cambial e acessar financiamento em moeda
                    estrangeira. Funciona como um acordo privado entre duas partes para trocar
                    fluxos de caixa em diferentes moedas durante um período predefinido.
                    Ele combina um contrato a termo de compra com um contrato a termo de
                    venda de moedas, permitindo que as empresas gerenciem o risco cambial e
                    acessem financiamento em moeda estrangeira. Veja como funciona:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Contrato Inicial: </span>As partes concordam em trocar um principal em duas
                    moedas diferentes a uma taxa de câmbio predefinida. Essa troca ocorre no
                    início do contrato.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Pagamentos Periódicos de Juros: </span>Durante a vigência do contrato, as partes
                    trocam pagamentos periódicos de juros com base em taxas de juros
                    predefinidas para cada moeda. Esses juros podem ser fixos ou flutuantes.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Troca Reversa do Principal: </span>No final do contrato, as partes trocam novamente
                    o principal, utilizando a mesma taxa de câmbio inicial. Isso efetivamente
                    reverte a troca inicial.
                </p>

                <div className='container-tipos-swap'>
                    <p>
                        Opções de Compra (Call): Dão o direito, mas não a obrigação, de comprar a moeda estrangeira a um preço predefinido. Oferecem flexibilidade caso a taxa de câmbio caia, mas têm um custo (prêmio).
                    </p>

                    <p>
                        NDF (Non-Deliverable Forward): Similar ao contrato a termo, mas usado para moedas com restrições. A liquidação é feita pela diferença entre a taxa acordada e a taxa spot.
                    </p>

                    <p>
                        Produtos Cambiais para Exportação (proteção contra queda da moeda estrangeira):
                    </p>
                </div>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgexport2} src={imgexport2} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        Previsibilidade de custos de importação: Ao fixar uma taxa de câmbio antecipadamente, a empresa sabe exatamente quanto pagará pela mercadoria em sua moeda local, independentemente das oscilações do mercado cambia, facilitando o planejamento financeiro e orçamentário, permitindo que a empresa projete seus custos com maior precisão.
                    </p>

                    <p>
                        Proteção contra a desvalorização da moeda local:
                        Se a moeda local se desvalorizar em relação à moeda estrangeira usada na transação de importação, a empresa estará protegida, pois já terá travado o custo na taxa de câmbio acordada.
                    </p>

                    <p>
                        Maior competitividade: Com custos previsíveis, a empresa pode definir preços de venda com maior segurança, o que a torna mais competitiva no mercado. Sem a incerteza cambial, é possível praticar preços mais agressivos e atrair mais clientes.
                    </p>

                    <p>
                        Melhora na gestão de fluxo de caixa: A previsibilidade dos custos de importação facilita o planejamento do fluxo de caixa da empresa, permitindo uma gestão financeira mais eficiente. A empresa pode se preparar com antecedência para os pagamentos, evitando surpresas desagradáveis.
                    </p>

                    <p>
                        Foco no core business: Ao eliminar a preocupação com as flutuações cambiais, a empresa pode se concentrar em suas atividades principais, como produção, vendas e marketing, sem se distrair com a gestão do risco cambial.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"10px"}}>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

